import { mapActions } from 'vuex';
import Analytics from '@/mixins/Analytics';
import GaiaGraphQLClient from '@/api/graphql/GaiaGraphQLClient';

const methods = {
  ...mapActions({
    clearUser: 'clearUser',
    removeFeatureFlags: 'removeFeatureFlags',
    unsubscribeCurrentUser: 'unsubscribeCurrentUser',
    clearAuctions: 'auctions/clearAuctions',
    clearCardSwitcherPreference: 'uiSettings/clearCardSwitcherPreference',
    deleteFirebaseRegistation: 'deleteFcmRegistration',
    clearSortingFilterSelection: 'laneSortingFilterSettings/clearSortingFilterSelection',
    resetMarketplaceParams: 'marketplaceRouter/resetMarketplaceParams',
    resetMarketplaceView: 'marketplaceView/resetMarketplaceView',
    clearSrpRefreshPreference: 'marketplaceView/clearSrpRefreshPreference',
    updateEulaReviewBannerVisibility: 'marketplaceView/updateEulaReviewBannerVisibility',
    resetAnnouncements: 'announcements/resetAnnouncements',
  }),
  async logout() {
    this.resetAnnouncements();
    await this.unsubscribeCurrentUser();
    await this.deleteFirebaseRegistation();
    // Clear the module so that a user can logout without
    // getting caught up in the redirects. - ETC
    await this.clearAuctions('BuyingOutstanding');
    await this.clearCardSwitcherPreference();
    this.resetMixpanel();
    await this.clearUser();
    await this.removeFeatureFlags();
    await this.clearSortingFilterSelection();
    await this.resetMarketplaceParams({ persistOnLogout: true });
    await this.resetMarketplaceView();
    await this.clearSrpRefreshPreference();
    this.updateEulaReviewBannerVisibility(true); // reset eula banner on logout
    GaiaGraphQLClient().stopAll();
  },
};

export default {
  methods,
  mixins: [Analytics],
};
